module.exports = __webpack_public_path__ + "media/images/lig/design-tiles/lig-tile-15-fbe0b51e458fc6fa9f4c67ac3e748823.jpg";